/**
 * @generated SignedSource<<2d4b18999f68447403c72fcc5e53cf61>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpTabs_viewer$data = {
  readonly nftBalancesByItem: ReadonlyArray<{
    readonly balance: number | null;
    readonly chainId: string | null;
    readonly ownerAddress: {
      readonly address: string | null;
      readonly publicProfile: {
        readonly displayName: string | null;
      } | null;
    } | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpHistory_viewer" | "NftPdpOwners_viewer">;
  readonly " $fragmentType": "NftPdpTabs_viewer";
};
export type NftPdpTabs_viewer$key = {
  readonly " $data"?: NftPdpTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "nftId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpTabs_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "nftId",
          "variableName": "nftId"
        }
      ],
      "concreteType": "NftItemBalance",
      "kind": "LinkedField",
      "name": "nftBalancesByItem",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chainId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "ownerAddress",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "address",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PublicProfile",
              "kind": "LinkedField",
              "name": "publicProfile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "balance",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpOwners_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpHistory_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9dccfa21bf3fe7800392ca3bb8161761";

export default node;
